import { cn } from "./internal/cn";
import { ClassValue } from "clsx";

type Props = {
  size?: number;
  className?: ClassValue;
};

export const LoadingIcon = ({ size = 34, className }: Props) => {
  return (
    <svg
      width={size}
      height={size + 34 / 33}
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className && className)}
    >
      <g clipPath="url(#clip0_19453_45928)">
        <path
          d="M16.5 8.75V4.625"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3438 11.1562L25.3 8.19995"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.75 17H28.875"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3438 22.8438L25.3 25.8"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 25.25V29.375"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6555 22.8438L7.69922 25.8"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 17H4.125"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6555 11.1564L7.69922 8.2002"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_19453_45928">
          <rect y="0.5" width="33" height="33" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
